import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const NgeniusCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 500, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <Cancel sx={{ fontSize: 64, color: '#d32f2f', mb: 2 }} />

          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Payment Cancelled
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment was cancelled. No charges have been made.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate('/account/payments')}
            sx={{
              bgcolor: '#064d51',
              '&:hover': { bgcolor: '#053d41' },
            }}
          >
            Go to Payments
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NgeniusCancelledPage;
